import {
  createBrowserRouter,
  Navigate,
  Outlet,
  useNavigation,
  useLocation,
} from "react-router-dom";
import { useOnlineStatus } from "../hook/useOnlineStatus";
// Layouts
import Header from "../layout/header";
import Player from "../layout/main";
import Footer from "../layout/footer";
import Sidebar from "../layout/sidebar";

// Pages
import Home from "../pages/home";
import Prodcast from "../pages/prodcasts/prodcast";
import ProEpisode from "../pages/prodcasts/proEpisode";
import GenrePro from "../pages/prodcasts/GenrePro";
import PlaySongs from "../pages/prodcasts/PlaySongs";
import PlayMusic from "../pages/music/playmusic";
import News from "../pages/news/news";
import Event from "../pages/event/event";
import Profile from "../pages/account/profile";
import Account from "../pages/account/accountsetting";
import UpgradePlane from "../pages/account/upgrade";
import About from "../pages/content/about";
import Term from "../pages/content/term&condition";
import Privacy from "../pages/content/privacypolicy";
import Faqs from "../pages/content/faqs";
import Login from "../auth/login";
import Register from "../auth/signup";
import ForgetPassword from "../auth/forget";
import VerifyOTP from "../auth/verifyOtp";
import ResetPassword from "../auth/resetpassword";
import Loader from "../loader/loader";
import TopLoader from "../loader/TopLoader";
import Trending from "../pages/trending";
import NewsDetails from "../pages/news/NewsDetails";
import Chat from "../chat/chatMessages";
import Subscription from "../pages/subscription";
import Artist from "../pages/music/artist";
import Album from "../pages/music/albhum";
import Song from "../pages/music/song";
import Checkout from "../pages/payment/Checkout";
import PaymentSuccess from "../pages/payment/PaymentSuccess";

import ArtistDashboard from "../pages/artistpanel/dashboard";
import ArtistAlbum from "../pages/artistpanel/album";
import ArtistEvent from "../pages/artistpanel/event";
import ArtistProdcast from "../pages/artistpanel/prodcast";
import ArtistSong from "../pages/artistpanel/song";
import Profiles from "../pages/artistpanel/profile";

import Music from "../pages/music/music";
import ArtistFoot from "../layout/ArtistFoot";
import Playlist from "../pages/playlist/Playlist";
import PlaylistId from "../pages/playlist/PlaylistID";
import AdminPlaylist from "../pages/playlist/AdminPlaylist";
import WishList from "../pages/playlist/Wishlist";
import ArtistSubscription from "../pages/artistpanel/artistSubscription";
import ArtistCheckout from "../pages/artistpanel/checkout";
import EventDetail from "../pages/event/eventDetail";
// If user is not authenticated (no token), don't allow entering protected route at all!
const ProtectedRoute = () => {
  const isAuthenticated = !!localStorage.getItem("volumeToken"); // Check existence of token, not a falsy string
  const location = useLocation();
  const userTypes = JSON.parse(localStorage.getItem("userTypes") || "[]");
  const currentUser = localStorage.getItem("current_user");
  useOnlineStatus();

  if (!isAuthenticated) {
    // Not authenticated, redirect to login immediately (don't allow any protected children to render)
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const isArtistRoute = location.pathname.startsWith("/artist");

  if (isArtistRoute && currentUser !== "Artist") {
    return <Navigate to="/" replace />;
  }

  if (location.pathname === "/" && currentUser === "Artist") {
    return <Navigate to="/artist/dashboard" replace />;
  }

  return <Outlet />;
};

// Public routes are only accessible if there is no valid token
const PublicRoute = () => {
  const isAuthenticated = !!localStorage.getItem("volumeToken");
  return !isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

const AppLayout = () => {
  const navigation = useNavigation();
  const userTypes = JSON.parse(localStorage.getItem("userTypes") || "[]");
  const currentUser = localStorage.getItem("current_user");

  return (
    <div>
      <TopLoader />
      <Sidebar />
      <main className="main-content">
        <Header />
        {navigation.state === "loading" ? (
          <Loader />
        ) : (
          <div>
            <Outlet />
          </div>
        )}
        <Footer />
      </main>
      {currentUser === "User" && <Player />}
    </div>
  );
};

const ArtistLayout = () => {
  const navigation = useNavigation();

  return (
    <div>
      <TopLoader />
      <Sidebar />
      <main className="main-content">
        <Header />
        {navigation.state === "loading" ? (
          <Loader />
        ) : (
          <div>
            <Outlet />
          </div>
        )}
        <ArtistFoot />
      </main>
    </div>
  );
};

export const router = createBrowserRouter(
  [
    // Protected routes
    {
      element: <ProtectedRoute />,
      children: [
        {
          element: <AppLayout />,
          children: [
            { path: "/", element: <Home /> },
            { path: "/profile", element: <Profile /> },
            { path: "/account-setting", element: <Account /> },
            { path: "/upgrade_plan", element: <UpgradePlane /> },
            { path: "/subscription", element: <Subscription /> },
            { path: "/subscription/checkout/:id", element: <Checkout /> },
            { path: "/about-us", element: <About /> },
            { path: "/terms-and-conditions", element: <Term /> },
            { path: "/privacy-policy", element: <Privacy /> },
            { path: "/faq", element: <Faqs /> },
            { path: "/podcasts", element: <Prodcast /> },
            { path: "/podcasts/genre-podcasts", element: <GenrePro /> },
            { path: "/trending", element: <Trending /> },
            { path: "/art/:id", element: <Artist /> },
            { path: "/album/:id", element: <Album /> },
            { path: "/news", element: <News /> },
            { path: "/news/:id", element: <NewsDetails /> },
            { path: "/events", element: <Event /> },
            { path: "/events/:id", element: <EventDetail /> },
            { path: "/music/:id", element: <Music /> },
            { path: "/episode/:id", element: <PlaySongs /> },
            { path: "/podcast-episode/:id/:source", element: <ProEpisode /> },
            { path: "/playlist", element: <Playlist /> },
            { path: "/playlists/:id", element: <PlaylistId /> },
            { path: "/like", element: <WishList /> },
            { path: "/admin-playlists/:id", element: <AdminPlaylist /> },
            { path: "/podcast-episode/:id/episode/:id", element: <Music /> },
            { path: "/party-music/:id", element: <PlayMusic /> },
            { path: "/:title/:id", element: <Song /> },
            { path: "/chat_message", element: <Chat /> },
            { path: "/payment-success", element: <PaymentSuccess /> },
          ],
        },
        {
          element: <ArtistLayout />,
          children: [
            { path: "/artist/dashboard", element: <ArtistDashboard /> },
            { path: "/artist/album", element: <ArtistAlbum /> },
            { path: "/artist/events", element: <ArtistEvent /> },
            { path: "/artist/events/:id", element: <EventDetail /> },
            { path: "/artist/podcasts", element: <ArtistProdcast /> },
            { path: "/artist/song", element: <ArtistSong /> },
            { path: "/artist/profile", element: <Profiles /> },
            { path: "/artist/about-us", element: <About /> },
            { path: "/artist/terms-and-conditions", element: <Term /> },
            { path: "/artist/privacy-policy", element: <Privacy /> },
            { path: "/artist/faq", element: <Faqs /> },
            { path: "/artist/subscription", element: <ArtistSubscription /> },
            {
              path: "/artist/subscription/checkout/:id",
              element: <ArtistCheckout />,
            },
          ],
        },
        { path: "*", element: <Navigate to="/" replace /> },
      ],
    },

    // Public routes are only accessible if not logged in (no valid token)
    {
      element: <PublicRoute />,
      children: [
        { path: "/login", element: <Login /> },
        { path: "/sign-up", element: <Register /> },
        { path: "/forgot-password", element: <ForgetPassword /> },
        { path: "/verify-otp", element: <VerifyOTP /> },
        { path: "/reset-password", element: <ResetPassword /> },
        { path: "*", element: <Navigate to="/login" replace /> },
      ],
    },
  ],
  {
    basename: "/",
  },
);
